import channels from "./channels";
import Connection from "./connection";
import Stack from "./stack";
import Demo from "./demo";
import { node } from "~/util/dom";
import { CONFIG } from "~/config";

const OPTIONS = {
	url: `wss://notifikace.mapy.${CONFIG.TLD}`,
	demo: false,
	log: false,
};

export default class SznNotifications {
	_connection: Connection;

	_session: "green" | "orange" | "red";

	node: HTMLDivElement;

	stacks: Array<Stack>;

	sessionUnread: any;

	constructor(opts = {}) {
		const options = {
			...OPTIONS,
			...opts,
		};

		this.sessionUnread = {};
		this._session = "green";
		this._connection = new Connection(options);
		this._connection.onMessage = data => this._onMessage(data);
		this._connection.onOpen = () => this._onOpen();
		this._connection.onClose = code => this._onClose(code);

		this.node = node("div", { className: "szn-notifications" });
		this.node.setAttribute("data-dot", "szn-notifications");

		this.stacks = [
			// new Email(this._connection),
			new Stack(this._connection, { filter: "general", icon: "email", hideUntilUsed: false, label: "Oznámení e-mailu" }),
			new Stack(this._connection, { filter: "promo", icon: "bell", hideUntilUsed: true, label: "Oznámení" }),
			new Stack(this._connection, { filter: "community", icon: "bubble", hideUntilUsed: false, label: "Oznámení diskuzí" }),
		];
		options.demo && this.stacks.push(new Demo());

		this.stacks.forEach(stack => this.node.appendChild(stack.button));
		this.stacks.forEach(stack => this.node.appendChild(stack.node));

		window.addEventListener("login", this);
		window.addEventListener("logout", this);
		window.addEventListener("forget", this);
		window.addEventListener("badge", this);
	}

	set interactiveButtons(ib) {
		this.stacks.forEach(stack => {
			stack.interactiveButton = ib;
		});
	}

	handleEvent(event) {
		switch (event.type) {
			case "login":
			case "logout":
				this._connection.close();
				this._connection.open();
				break;

			case "forget": // neni session -> potichu strhnout spojeni
				this._connection.close();
				this._onClose(false);
				break;

			case "badge": {
				const type = event.detail.state;

				if (type === "login" && this._session === "green") {
					return;
				}
				if (type === "logout" && this._session === "orange") {
					return;
				}
				if (type === "forget" && this._session === "red") {
					return;
				}

				this.handleEvent({ type });
				break;
			}

			default:
				//
		}
	}

	_onMessage(data: any) {
		switch (data.type) {
			case "user.channel.list":
				this._connection.uid = data.uid;

				data.channels.forEach(ch => {
					channels[ch.id] = ch;
				});
				this._session = data.session;
				this.stacks.forEach(stack => stack.onSession(this._session));

				this._getSessionState(); // pocet nectenych napric session
				break;

			case "user.state.changed":
				this._getSessionState(); // pocet nectenych napric session
				break;

			case "session.state":
				this.sessionUnread = data;
				this.node.dispatchEvent(new CustomEvent("session-unread-change", { bubbles: true }));
				break;

			case "user.message":
				if (data.uid && data.uid !== this._connection.uid) {
					return;
				} // pro jineho uzivatele
				break;

			default:
				//
		}

		this.stacks.forEach(stack => stack.onMessage(data));
	}

	_onOpen() {
		this._connection.send("user.channel.list");
	}

	_onClose(willRetry) {
		if (willRetry) {
			this.stacks.forEach(stack => stack.onDisconnect());
		} else {
			this._session = "red";
			this.stacks.forEach(stack => stack.onSession(this._session));
		}
	}

	_getSessionState() {
		this._connection.send("session.state", { filter: "all" });
	}
}
